import React, { useState } from "react";

//components material mui
import {
    Dialog,
    DialogTitle,
    IconButton,
    Typography,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

//hooks
import { useGlobalState } from "../../../Utilidades/useGlobalState";

let funcionAbrirModal;
let validaAbrirModal;

/**
 * Modal full-screen que monta el iframe de la pasarela de pago.
 * La pasarela procesa el pago dentro del iframe; al cerrar se notifica
 * al padre via onCerrar para validar si el pago se proceso.
 *
 * @param {{ url:string, datos:(string|number), idioma:string, onCerrar:(function|undefined) }} param0
 */
export const DialogoPagoEnLinea = ({ url = "", datos = "", idioma = "es", onCerrar = undefined }) => {
    const { etiquetas } = useGlobalState();

    const [abierto, setAbierto] = useState(false);
    funcionAbrirModal = setAbierto;
    validaAbrirModal = abierto;

    const cerrar = () => {
        setAbierto(false);
        if (onCerrar !== undefined) onCerrar();
    };

    const srcIframe = url + `?data=${datos}&lang=${idioma}`;
    const srcValido = url !== "" && url !== "#" && !srcIframe.includes("undefined") && !srcIframe.includes("null");

    return (
        <Dialog open={abierto} onClose={cerrar} fullScreen>
            <DialogTitle
                style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#082375",
                    color: "#FFFFFF",
                    padding: "8px 16px",
                }}
            >
                <Typography component="span" style={{ flexGrow: 1, fontSize: 18, fontWeight: 600 }}>
                    {etiquetas?.PagoEnLinea?.Et_TituloPrincipal || "Pago en Línea"}
                </Typography>
                <IconButton aria-label="cerrar" onClick={cerrar} style={{ color: "#FFFFFF" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Box style={{ flex: 1, width: "100%", height: "100%", padding: 0 }}>
                {srcValido ? (
                    <iframe
                        title={etiquetas?.PagoEnLinea?.Et_TituloPrincipal || "Pago en línea"}
                        src={srcIframe}
                        style={{ border: "0px", width: "100%", height: "100%", minHeight: "80vh" }}
                    />
                ) : (
                    <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", padding: 20 }}>
                        <Typography>{etiquetas?.PagoEnLinea?.Et_Redireccion || ""}</Typography>
                    </Box>
                )}
            </Box>
        </Dialog>
    );
};

export const mostrarDialogoPagoEnLinea = () => {
    funcionAbrirModal(!validaAbrirModal);
};
